export default "__VITE_ASSET__Dbn8PeUI__"